import * as Sentry from '@sentry/browser';

import APIError from './error-types/api.error';
import APIMappedError from './error-types/api.mapped.error';
import APIUnAuthorizedError from './error-types/api.unauthorized.error';
import ConnectionError from './error-types/connection.error';
import EDFError from './error-types/edf.error';
import FatalError from './error-types/fatal.error';
import UnknownError from './error-types/unknown.error';
import ValidationError from './error-types/validation.error';

function anError(error: Error): Error {
    const errorTypesToHandle = [FatalError, APIError, UnknownError, EDFError, ValidationError, TypeError];
    const errorTypesToExclude = [APIMappedError, APIUnAuthorizedError, ConnectionError];

    const isErrorOfInterest =
        errorTypesToHandle.some((type) => error instanceof type) && !errorTypesToExclude.some((type) => error instanceof type);

    // eslint-disable-next-line no-console
    console.error(error.stack || 'No stack trace available');

    if (isErrorOfInterest) {
        Sentry.withScope((scope) => {
            scope.setTag('catch_in', 'errorHandler');
            scope.setExtras({
                stackTrace: error.stack || 'No stack trace available',
                name: error.constructor.name || 'externalLog',
            });
            Sentry.captureException(error);
        });
    }

    return error;
}

export { anError };
